const couponsTypes = {

  get: {
    request: "GET_COUPON_REQUEST",
    success: "GET_COUPON_SUCCESS",
    failure: "GET_COUPON_FAILURE"
  },

  index: {
    request: "COUPONS_INDEX_REQUEST",
    success: "COUPONS_INDEX_SUCCESS",
    failure: "COUPONS_INDEX_FAILURE",
    select:  "COUPONS_INDEX_SELECT"
  },

  create: {
    init:    "CREATE_COUPON_INIT",
    request: "CREATE_COUPON_REQUEST",
    success: "CREATE_COUPON_SUCCESS",
    failure: "CREATE_COUPON_FAILURE"
  },

  update: {
    request: "UPDATE_COUPON_REQUEST",
    success: "UPDATE_COUPON_SUCCESS",
    failure: "UPDATE_COUPON_FAILURE"
  },

  publish: {
    request: "COUPON_OPERATION_REQUEST",
    success: "COUPON_OPERATION_SUCCESS",
    single: "COUPON_OPERATION_SINGLE_SUCCESS",
    failure: "COUPON_OPERATION_FAILURE"
  },

  reset_token: {
    request: "RESET_TOKEN_COUPON_REQUEST",
    success: "RESET_TOKEN_COUPON_SUCCESS",
    failure: "RESET_TOKEN_COUPON_FAILURE"
  },

  set_errors: "SET_COUPON_ERRORS",

  reset_coupon: "RESET_COUPON",

  clear_coupon: "CLEAR_COUPON",

}

export default couponsTypes



// WEBPACK FOOTER //
// ./src/js/constants/couponsTypes.js